import React from 'react';
export function StickyAlertBar() {
  return <div className="sticky top-0 z-50 bg-primary text-white py-2.5 px-4 text-center font-sans" data-id="element-425">
      <p className="text-sm md:text-base font-semibold" data-id="element-426">
        ⚡ <span className="font-bold" data-id="element-427">OFERTA POR TIEMPO LIMITADO:</span> Accede
        a +1.000 Actividades por solo 12,99 € —
        <span className="underline ml-1" data-id="element-428">¡Antes de que suba el precio!</span>
      </p>
    </div>;
}